import get from 'lodash/get'

export const DRAWER_TABS_PANELS_EXPANDED_BASE_PATH = 'layout.drawer.expanded'
export const CONFIG_DRAWER_TAB_ACTIVE_PATH = 'layout.drawer.tabs.activetabid'
export const CONFIG_DRAWER_TAB_LOADED_PATH = 'layout.drawer.tabs.loaded'

export const SET_CONFIG = 'SET_CONFIG' // Sets the base config.. only call once.

export const SET_CONFIG_DRAWER_TAB_ACTIVE = 'SET_CONFIG_DRAWER_TAB_ACTIVE'
export const CONFIG_DRAWER_TAB_ACTIVE_SEARCH = 'search'
export const CONFIG_DRAWER_TAB_ACTIVE_INFO = 'info'
export const CONFIG_DRAWER_TAB_ACTIVE_LAYERS = 'layers'
export const CONFIG_DRAWER_TAB_ACTIVE_TOOLS = 'tools'
export const CONFIG_DRAWER_TAB_ACTIVE_ABOUT = 'about'

export const SET_CONFIG_DRAWER_TAB_ACTIVE_BACKGROUND_LOAD = 'SET_CONFIG_DRAWER_TAB_ACTIVE_BACKGROUND_LOAD'
export const INCREMENT_LAYER_COUNT = 'INCREMENT_LAYER_COUNT'

export const LAYOUT_DRAWER_TABS_TOOLS_ANNOTATIONS_EXPANDED = 'layout.drawer.tabs.tools.annotations.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_LOGIN_EXPANDED = 'layout.drawer.tabs.tools.login.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_DOWNLOAD_EXPANDED = 'layout.drawer.tabs.tools.download.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_MEASURE_EXPANDED = 'layout.drawer.tabs.tools.measure.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_SELECTGROUP_EXPANDED = 'layout.drawer.tabs.tools.selectgroup.expanded'

export const LAYOUT_DRAWER_TABS_TOOLS_PRINT_EXPANDED = 'layout.drawer.tabs.tools.print.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_LINESELECT_EXPANDED = 'layout.drawer.tabs.tools.lineselect.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_POLYGONSELECT_EXPANDED = 'layout.drawer.tabs.tools.polygonselect.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_BUFFERSELECT_EXPANDED = 'layout.drawer.tabs.tools.bufferselect.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_PROPERTYLOOKUP_EXPANDED = 'layout.drawer.tabs.tools.propertylookup.expanded'
export const LAYOUT_DRAWER_TABS_TOOLS_SHARE_EXPANDED = 'layout.drawer.tabs.tools.share.expanded'

export const LAYOUT_DRAWER_TABS_ABOUT_PANELS_DETAILS_EXPANDED = 'layout.drawer.tabs.about.panels.details.expanded'
export const LAYOUT_DRAWER_TABS_ABOUT_PANELS_SUPPORT_EXPANDED = 'layout.drawer.tabs.about.panels.support.expanded'
export const LAYOUT_DRAWER_TABS_ABOUT_PANELS_NEWS_EXPANDED = 'layout.drawer.tabs.about.panels.news.expanded'
export const LAYOUT_DRAWER_TABS_ABOUT_PANELS_TIPS_EXPANDED = 'layout.drawer.tabs.about.panels.tips.expanded'
export const LAYOUT_DRAWER_TABS_ABOUT_PANELS_FEEDBACK_EXPANDED = 'layout.drawer.tabs.about.panels.feedback.expanded'

export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED = 'layout.drawer.tabs.search.panels.find.expanded'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED = 'layout.drawer.tabs.search.panels.directions.expanded'
export const PANELS_COMBINED_SEARCH = [
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED
]

export const DRAWER_TABS_PANELS_TOGGLE = 'DRAWER_TABS_PANELS_TOGGLE'
export const TOGGLE_TYPE_TOGGLE = 'TOGGLE_TYPE_TOGGLE'
export const TOGGLE_TYPE_OPEN = 'TOGGLE_TYPE_OPEN'
export const TOGGLE_TYPE_CLOSE = 'TOGGLE_TYPE_CLOSE'

export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE = 'layout.drawer.tabs.search.panels.directions.travelMode'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM = 'layout.drawer.tabs.search.panels.directions.traveldistancekm'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM_SHORTEST = 'layout.drawer.tabs.search.panels.directions.traveldistancekmshortest'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER = 'layout.drawer.tabs.search.panels.directions.pathFinder'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER_SHORTEST = 'layout.drawer.tabs.search.panels.directions.pathFinderShortest'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION = 'layout.drawer.tabs.search.panels.directions.startLocation'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION = 'layout.drawer.tabs.search.panels.directions.endLocation'
export const LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_LOCATION = 'layout.drawer.tabs.search.panels.directions.location'

export const setConfig = config => ({
  type: SET_CONFIG,
  config
})

// Utility (not an action)
export const getPanelIDFromConfigPath = (panelConfigPath) => {
  let panelid = ''
  try {
    panelid = panelConfigPath.replace('.expanded', '')
    panelid = panelid.substring(panelid.lastIndexOf('.') + 1, panelid.length)
  } catch (e) {
    console.log(e)
  }
  return panelid
}

// Finds the expanded panel from the panelid and active tab.
// E.g. panelid of 'find' returns LAYOUT_DRAWER_TABS_SEARCH_PANELS_FIND_EXPANDED
// Requires all panels have a unique name.
// Utility (not an action)
export const getExpandedConfigPathFromPanelID = (panelid) => {
  let expandedPanelConfigPath = ''
  try {
    const state = window.store.getState()
    const activeTabId = get(state, 'config.' + CONFIG_DRAWER_TAB_ACTIVE_PATH, '')
    if (activeTabId === CONFIG_DRAWER_TAB_ACTIVE_SEARCH) {
      expandedPanelConfigPath = PANELS_COMBINED_SEARCH.find(function (panelConfigPath) {
        let matchWithPanelID = panelConfigPath.replace('.expanded', '')
        matchWithPanelID = matchWithPanelID.substring(matchWithPanelID.lastIndexOf('.') + 1, matchWithPanelID.length)
        return matchWithPanelID === panelid
      }) || ''
    }
  } catch (e) {
    console.log(e)
  }

  return expandedPanelConfigPath
}

export const togglePanel = (panelConfigPath, toggleType) => {
  return (dispatch) => {
    dispatch({
      type: DRAWER_TABS_PANELS_TOGGLE,
      panelConfigPath,
      toggleType
    })
  }
}

export const setActiveTab = (activetabid) => ({
  type: SET_CONFIG_DRAWER_TAB_ACTIVE,
  activetabid
})

export const setActiveTabBackgroundLoad = (activetabid) => ({
  type: SET_CONFIG_DRAWER_TAB_ACTIVE_BACKGROUND_LOAD,
  activetabid
})

export const incrementLayerCount = (count = 1) => ({
  type: INCREMENT_LAYER_COUNT,
  count
})

export const setDirectionsTravelDistanceKM = (travelDistanceKM) => ({
  type: LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM,
  travelDistanceKM
})

export const setDirectionsTravelDistanceKMShortest = (travelDistanceKMShortest) => ({
  type: LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM_SHORTEST,
  travelDistanceKMShortest
})

export const setDirectionsTravelMode = (travelMode, pathFinder, pathFinderShortest) => ({
  type: LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE,
  travelMode,
  pathFinder,
  pathFinderShortest
})

export const setDirectionsStartLocation = (coords, geojson) => {
  return dispatch => {
    dispatch({
      type: LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION,
      startLocation: {
        coords,
        geojson
      }
    })
  }
}

export const setDirectionsEndLocation = (coords, geojson) => {
  return dispatch => {
    dispatch({
      type: LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION,
      endLocation: {
        coords,
        geojson
      }
    })
  }
}

/**
 * Note: start/endLocation = { coords: [lng,lat], geojson: {...} }
 */
export const setDirectionsLocationFromCoords = coords => {
  const state = window.store.getState()
  const startLocation = get(state.config, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_START_LOCATION, {})
  const coordsStartLocation = get(startLocation, 'coords', [])
  if (coordsStartLocation.length === 0) {
    return setDirectionsStartLocation(coords)
  } else {
    return setDirectionsEndLocation(coords)
  }
}
